// extracted by css-extract-rspack-plugin
export default {"tabs":"LinkTab__tabs--b7bG3"};